import { useCallback, useEffect } from "react"
import { batch, useComputed, useSignal } from "@preact/signals-react"
import { formatDate, getYear, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { companyUsers } from "@signals"
import { dateUserTableData, isDateRangeLoading, userSiteTableData } from "Pages/Main/Home/@signals"


export default function useSearchAnalyticsDateRangeInfo() {
	const dateRange = [new Date(getYear(), new Date().getMonth()), new Date()]
	const pieChartData = useSignal({})
	const data = useComputed(() => {
		if (!isDateRangeLoading.value) {
			return pieChartData.value
		}
		return {}
	})

	const getDateRangeInfo = useCallback(() => {
		isDateRangeLoading.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/date-range`, {
			uid: companyUsers.value,
			startBookingDate: formatDate(dateRange[0], { format: 'yyyy-MM-dd' }),
			endBookingDate: formatDate(dateRange[1], { format: 'yyyy-MM-dd' })
		}).then(({
					 bookingDateUser,
					 bookingDateUserSorted,
					 percentageSite,
					 siteSeries,
					 userSite
				 }) => batch(() => {
			pieChartData.value = { percentageSite: percentageSite, siteSeries: siteSeries }
			userSiteTableData.value = userSite
			dateUserTableData.value = {
				bookingDateUserSorted: bookingDateUserSorted,
				bookingDateUser: bookingDateUser
			}
			isDateRangeLoading.value = false
		})).catch(() => {
			isDateRangeLoading.value = false
		})
	}, [JSON.stringify(companyUsers.value)])

	useEffect(() => {
		getDateRangeInfo()
	}, [JSON.stringify(companyUsers.value), JSON.stringify(dateRange.value)])

	return {
		data: data.value,
		isDateRangeLoading: isDateRangeLoading.value,
	}
}